module.exports = __webpack_public_path__ + "img/grade17.dca1ff7a.png";